import { Dropdown } from "@carbon/react";
import { Controller, UseFormReturn } from "react-hook-form";

import { useCreateError } from "src/errors";
import { useGetPropertiesQuery } from "src/graphql/anti-fraud/queries/rules/PropertiesQuery";
import { useGetPropertyLabel } from "src/hooks/useGetPropertyLabel";

import { SimleRuleFormData } from "./useSimpleRuleDefinition";

type SimpleRulePropertyFormFieldProps = {
  index: number;
  id: string;
  caseTypeCode?: string;
  methods: UseFormReturn<SimleRuleFormData>;
};

export function SimpleRulePropertyFormField({
  index,
  id,
  caseTypeCode,
  methods,
}: SimpleRulePropertyFormFieldProps) {
  const createError = useCreateError();

  const { data: items } = useGetPropertiesQuery({
    onError: () => {
      const error = createError("FETCH-PROPERTIES-ERROR", null);
      methods.setError("criteria", { message: error.message });
    },
    caseTypeCode,
  });

  const getPropertyLabel = useGetPropertyLabel();

  return (
    <Controller
      name={`criteria.${index}.property`}
      control={methods.control}
      render={({ field, fieldState }) => {
        return (
          <Dropdown
            className=""
            id={`property-${id}`}
            titleText=""
            label=""
            items={items}
            itemToString={(item) => {
              return item && item.propertyCode
                ? `${item.prefix}-${getPropertyLabel(item.propertyCode)}`
                : "";
            }}
            selectedItem={
              items.find(
                (item) =>
                  item.clientType === field.value?.type &&
                  item.elementCode === field.value?.elementCode &&
                  item.propertyCode === field.value?.code
              ) || null
            }
            onChange={({ selectedItem }) => {
              field.onChange({
                dataType: selectedItem?.dataType,
                elementCode: selectedItem?.elementCode,
                code: selectedItem?.propertyCode,
                type: selectedItem?.clientType,
              });
            }}
            invalid={!!fieldState.error}
            invalidText={fieldState.error?.message || ""}
            warn={false}
          />
        );
      }}
    />
  );
}
